<template>
    <ur-modal class="ur-scheduler__modal" ref="cruModal" :title="modalTitle">
        <template #default>
            <ur-form-box class="ur-scheduler__modal-form-box" :col=1>
                <ur-form-item label="Title" class="ur-scheduler__modal-form-box__title">
                    <ur-text-field v-model="crudItem.title"></ur-text-field>
                </ur-form-item>
                <ur-form-item label="Color" class="ur-scheduler__modal-form-box__color">
                    <ur-icon-button class="primary" :class="isSelectedColor('primary-color')? 'selected-color' : ''"
                                    icon="favorite" icon-type="picto" borderless @click="clickedColor('primary-color')"/>
                    <ur-icon-button class="point" :class="isSelectedColor('point-color')? 'selected-color' : ''"
                                    icon="favorite" icon-type="picto" borderless @click="clickedColor('point-color')"/>
                    <ur-icon-button class="red" :class="isSelectedColor('red-color')? 'selected-color' : ''"
                                    icon="favorite" icon-type="picto" borderless @click="clickedColor('red-color')"/>
                    <ur-icon-button class="orange" :class="isSelectedColor('orange-color')? 'selected-color' : ''"
                                    icon="favorite" icon-type="picto" borderless @click="clickedColor('orange-color')"/>
                    <ur-icon-button class="yellow" :class="isSelectedColor('yellow-color')? 'selected-color' : ''"
                                    icon="favorite" icon-type="picto" borderless @click="clickedColor('yellow-color')"/>
                    <ur-icon-button class="green" :class="isSelectedColor('green-color')? 'selected-color' : ''"
                                    icon="favorite" icon-type="picto" borderless @click="clickedColor('green-color')"/>
                    <ur-icon-button class="blue" :class="isSelectedColor('blue-color')? 'selected-color' : ''"
                                    icon="favorite" icon-type="picto" borderless @click="clickedColor('blue-color')"/>
                    <ur-icon-button class="navy" :class="isSelectedColor('navy-color')? 'selected-color' : ''"
                                    icon="favorite" icon-type="picto" borderless @click="clickedColor('navy-color')"/>
                    <ur-icon-button class="violet" :class="isSelectedColor('violet-color')? 'selected-color' : ''"
                                    icon="favorite" icon-type="picto" borderless @click="clickedColor('violet-color')"/>
<!--                    <ur-icon-button class="default" icon="favorite" icon-type="picto" borderless/>-->
                </ur-form-item>
                <ur-form-item label="Start Date">
                    <ur-date-picker v-model="crudItem.startDate" init="today"/>
                    <ur-time-picker v-model="crudItem.startTime" mode="dropdown" class="ur-scheduler__modal-time-picker"/>
                </ur-form-item>
                <ur-form-item label="End Date">
                    <ur-date-picker v-model="crudItem.endDate" init="today"/>
                    <ur-time-picker v-model="crudItem.endTime" mode="dropdown" class="ur-scheduler__modal-time-picker"/>
                </ur-form-item>
            </ur-form-box>
        </template>
        <template #action>
            <ur-button @click="closed">Cancel</ur-button>
            <ur-button @click="deleted">Delete</ur-button>
            <ur-button @click="saved" main>Save</ur-button>
        </template>
    </ur-modal>
</template>

<script>
//ur-scheduler-cru-modal은 스케쥴러에 일정을 등록,조회,수정,삭제할 수 있도록 하는 모달입니다.
//#ur-scheduler-cru-modal is a modal component allows the user to CRUD for the scheduler component.
export default {
    name :'ur-scheduler-cru-modal',
    props: {
        // $ver: v0.2.0
        // CRUD 모달의 모드를 설정한다(add or edit)
        // #Set CRUD modal mode(add or edit)
        // $tags IDE
        mode: {type: String, default: 'add'}
    },
    computed:{
      modalTitle(){
          return (this.mode === 'add')? 'Add Event' : 'Event Detail & Edit';
      }
    },
    created(){
        this.setInitItem();
    },
    data() {
        return {
            cruModalTitle: 'Test Scheduler',
            crudItem: undefined
        }
    },
    methods: {
        open(item) {
            if(!!item){
                this.crudItem.title = item.title;
                this.crudItem.classes = item.classes;
                this.crudItem.startDate = item.startDate;
                this.crudItem.startTime = item.startTime;
                this.crudItem.endDate = item.endDate;
                this.crudItem.endTime = item.endTime;
            }
            this.$refs.cruModal.open();
        },
        deleted(){
            this.$emit('closed','delete', this.crudItem);
            this.closed(true);
        },
        saved(){
            this.$emit('closed',this.mode, this.crudItem);
            this.closed(true);
        },
        closed(flag) {
            this.setInitItem();
            this.$refs.cruModal.close(flag);
        },
        isSelectedColor(color){
            return (this.crudItem.classes === color);
        },
        clickedColor(color){
            this.crudItem.classes = color;
        },
        setInitItem(){
            this.crudItem = {
                title: '',
                classes: 'default-color',
                startDate: '',
                startTime: '12:00:00 AM',
                endDate: '',
                endTime: '12:00:00 AM'
            }
        }
    }
};
</script>
